export const formRule = {
  name: [{ required: true, message: '租户名未填写', trigger: 'blur' }],
  mobile: [
    {
      pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
      message: '手机号格式不正确',
      trigger: 'blur'
    }
  ],
  telephone: [
    {
      pattern: /0\d{2,3}-\d{7,8}/,
      message: '手机号格式不正确',
      trigger: 'blur'
    }
  ],
  email: [
    {
      pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
      message: '邮箱格式不正确',
      trigger: 'blur'
    }
  ]
}
